import { Component } from '@angular/core';

@Component({
  selector: 'app-valider-cra-client-final',
  templateUrl: './valider-cra-client-final.component.html',
  styleUrls: ['./valider-cra-client-final.component.css']
})
export class ValiderCraClientFinalComponent {

}
